<template>
    <div>
        <base-spinner v-if="isLoading"/>
        <base-page v-else>
            <hemocir-button
                :title="$t('surgery.addSurgery')"
                :to="{name: 'surgery-add', params: { patientId: this.patient.id }}"
                font-awesome-icon="fa-plus-circle"
                variant="secondary"
                class="mb-3"
            />

            <list-surgery-element
                v-for="(surgery, index) in patient.surgeries"
                :key="'surgery-' + surgery.id"
                :id-prefix="'surgery-' + surgery.id"
                :index="index"
                class="mb-3"
                @save="addingSurgery = false"
                @editsurgery="editSurgery"
                @gotolegend="goToLegend"
            />

            <div v-if="patient.surgeries.length > 0" class="d-flex">
                <base-legend
                    id="thelegend"
                    class="d-flex float-left mb-3"
                    :complete-legend-helper="$t('surgery.completelabel')"
                    :incomplete-legend-helper="$t('surgery.incompletelabel')"
                />
            </div>
        </base-page>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import ListSurgeryElement from "@/components/surgery/ListSurgeryElement";
    import BasePage from "@/components/BasePage";
    import BasePageMixin from "@/components/BasePageMixin";
    import BaseSpinner from "@/components/BaseSpinner";
    import BaseLegend from "@/components/BaseLegend";

    export default {
        name: "PatientDetailSurgeriesPage",
        components: {
            BaseLegend,
            BaseSpinner,
            BasePage,
            ListSurgeryElement,
        },
        mixins: [BasePageMixin],
        computed: {
            ...mapState(['patient']),
        },
        async created() {
            await this.getSurgeryOptions();
            await this.getFinalEvaluationOptions();
            await this.getBloodTestOptions();
            this.isLoading = false;
        },
        methods: {
            ...mapActions(['getSurgeryOptions', 'getFinalEvaluationOptions', 'getBloodTestOptions',]),
            editSurgery(surgeryId) {
                this.$emit('editsurgery');
                this.$router.push({
                    name: 'surgery-detail',
                    params: { surgeryId: surgeryId}
                });
            },
            goToLegend() {
                this.$nextTick(function () {
                    const element = document.getElementById('thelegend');
                    element.scrollIntoView({behavior: 'smooth'});
                });
            }
        },
    };
</script>

<style scoped>

</style>